/* 
FileName:index.js
purpose:To se all the archive data
Developers:Naveen Kumar Gade[NKG],Satya Sidda[SS]

 */
import React, { useEffect, useReducer, useState } from 'react';
import TopNavWithOutProject from '../Utility/TopNav/topnav';
import { useSelector } from 'react-redux';
import { tasksReducer, initialState } from './tasksReducer';
import RootLoader from '../../Common/Loader/RootLoader';
import Moment from 'moment';
import MainTaskInfo from '../../Common/TasksModals/mainTaskInfo';
import { getSubStringId } from '../../Common/SubStringConvert';
import { getToken } from '../../Common/LocalStorage';
import { getSubTasksBySprint } from './Services/getSubTasksBySprint';
import { Link } from 'react-router-dom';

export default function CompletedSubTasks() {


    const getUser = useSelector(state => state.auth)
    const [state, dispatch] = useReducer(tasksReducer, initialState)
    const [open, setOpen] = useState({ status: false, index: 0 })
    const [cardInfo, setCardInfo] = useState()
    const [searchWord, setSearchWord] = useState('')
    // eslint-disable-next-line
    const [chatOpen, setChatOpen] = useState(false);
    const webProperties = useSelector(state => state.landingReducer.webProperties);

    useEffect(() => {
        getSubTasksBySprint(dispatch, getUser.user, getToken("Archive_sprint_id"))
        // getAllTaskMessages(dispatch, getUser.user);
        // eslint-disable-next-line
    }, [])
    const handleOpen = (action, index, sno) => {
        var info
        setOpen({ status: true, index: index, action: action });
        // console.log(index)
        if (action === "unassigned_taskInfo") {

            var view_status1 = "taskInfo"
            info = {
                view: view_status1,
                projectName: index.projectitle,
                moduleName: index.moduletitle,
                title: index.tasktitle,
                description: index.taskdescription,
                taskId: index.taskid,
                targetDate: index.targettime,
                timeLeft: index.timeLeft,
                extraHours: index.extraHours,
                status: index.completeStatus,
                createdDate: index.assignedon,
                taskProgress: index.taskStatus,
                storyPoints: index.storyPoints,
                acceptanceCriteria: index.acceptanceCriteria,
                assignedTo: index.assignto,
                assignedBy: index.assignby,
                completedDate: index.modifiedDate,
                completedStatus: index.completeStatus,
                us_id: index.us_id,


            }

        }
        else if (action === "taskInfo") {
            info = {
                us_id: index.us_id,
                taskTitle: index.tasktitle,
                subTaskDesc: index.taskDesc,
                assignedBy: index.assignedBy,
                assignedTo: index.assignedTo,
                targetDate: index.targetDate,
                task: index.taskTitle,

            }
        }
        else if (action === "commentInfo") {
            info = {
                us_id: index.us_id,
                title: index.tasktitle,
                id: index.taskid,
            }

        }
        else {
            info = { action: action, id: state.currentTasks[index].taskid, sno: sno }
        }
        setCardInfo(info)
    };
    const handleClose = () => {

        setOpen({ status: false, index: 0 });

    };
    const handleModalClose = () => {
        setOpen({ status: false, index: 0 });
    }

    return (
        <div className="container-scroller">
            <TopNavWithOutProject />

            <div className="mt-2">
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div>
                                <h2 className="card-title" style={{ overflowWrap: "break-word", color: 'blue', backgroundColor: 'transparent' }}> {getToken("Archive_sprint_title").concat('   [', Moment(getToken("Archive_sprint_startDate")).format('MM.DD.YYYY'), '-', Moment(getToken("Archive_sprint_targetDate")).format('MM.DD.YYYY'), ']')}</h2>
                            </div>
                            <div className="d-flex justify-content-between mb-1 align-items-center justify-content-center">

                            <div>
                            <Link to={{ pathname:'/Archive'}} className=''>
                               <button style={{ backgroundColor: webProperties?.PRIMARY_COLOR !== "#47974b" ? webProperties?.PRIMARY_COLOR : '#47974b', color: 'white' }} >Back</button>
                                </Link>
                               
                            </div>

                                <div class="input-group-prepend">
                                <span class="text" style={{ color: 'black', paddingRight:5,paddingLeft:10,marginTop:'5px' }}>Search</span>
                             
                                <input type="text" className ="form-control form-control-sm" style={{ backgroundColor: 'transparent', borderBottom: '2px solid black', borderTop: '2px solid black', borderLeft: '12x solid black', borderRight: '2px solid black' }}
                                    onChange={(event) => setSearchWord(event.target.value)}
                                />
                                </div>

                            </div>

                            {state.isLoading ? <RootLoader /> :
                                <div>
                                    {/* eslint-disable-next-line */}
                                    {state.archiveSubTasks.length > 0 ? state.archiveSubTasks.filter((val) => {
                                        if (searchWord === "") {
                                            return val
                                        } else if ((`${getSubStringId(getUser.user.corp, 3)}-${val.taskTitle}`).toLowerCase().includes(searchWord.toLowerCase())) {
                                            return val
                                        }
                                    })
                                        .map((tasks, index) => {
                                            return (
                                                <div className="col-12" key={tasks.taskid}>
                                                    {/* {console.log(tasks)} */}
                                                    <div className="card col-12">
                                                        <div className="container-fluid col-12 row" >
                                                            <div class="d-flex col-12" style={{ padding: 0 }}>
                                                                <div class="mr-auto p-2">
                                                                    <td onClick={(event) => handleOpen("taskInfo", tasks)} style={{ textTransform: "capitalize", cursor: 'pointer' }} data-toggle="tooltip" data-placement="left" title={"Description     :" + tasks.taskDesc + "\n\nAssigned By    :" + tasks.assignedBy + "\n\nAssigned Date :" + tasks.assignedDate}>{tasks.taskstatus === 'pending' ? <b>{tasks.taskTitle}</b> : <del> <b>{getSubStringId(getUser.user.corp, 3)}{'-'}{tasks.us_id}{'-'}{tasks.taskTitle}</b></del>}</td>

                                                                    {/* <b style={{ cursor: 'pointer', paddingTop: 10, fontSize: '12px' }} onClick={(event) => handleOpen("taskInfo", index)}><del> {getSubStringId(getUser.user.corp, 3)}{'-'}{getSubStringId(tasks.subTaskId, 5)}{'-'}{tasks.tasktitle}</del></b> */}
                                                                </div>
                                                                {/* <button type="button" style={{ backgroundColor: 'transparent', border: "0", marginLeft: 10, width: '10px', padding: "0" }} >
                                                                            {
                                                                                getMessagesCount(tasks.us_id, state.allMessages, getUser.user.empId)
                                                                            }
                                                                        </button> */}
                                                                {/* <button style={{
                                                                            border: "0",
                                                                            width: "8px",
                                                                            height: "30px",
                                                                            backgroundColor: "transparent",
                                                                        }}
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleOpen(
                                                                                    "commentInfo", tasks
                                                                                )
                                                                            }
                                                                        >
                                                                            <img
                                                                                src="images/common/comments.svg"
                                                                                title={COMMENTS}
                                                                                alt="logo"
                                                                                style={{ width: "20px", height: "25px", marginLeft: "-17px" }}
                                                                            />
                                                                        </button> */}


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            )
                                        }
                                        ) : null}
                                    {
                                        open.action === "taskInfo" ? <MainTaskInfo open={open.status} handleClose={handleClose} data={cardInfo} handleModalClose={handleModalClose}
                                        /> : null
                                    }




                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}